import React from "react";
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import Dropdown from "./Dropdown";
import TextInputBlock from "./TextInputBlock";
import TextOutputBlock from "./TextOutputBlock";
import Popover from "./Popover";
import Errors from "./Errors";
import langs from "./langs"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import review from '../assets/review.svg';
import info from '../assets/info-ico.svg';

export default class Translator extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            model: {
                autoDetect: {id: "", name: 'Auto-Detect Language'},
                from: {id: this.props.data.defaultSource, name:langs[this.props.data.defaultSource]}, 
                to: {id: this.props.data.defaultTarget, name:langs[this.props.data.defaultTarget]},
                text: "",
                files: [],
                engine: null,
                provider: this.props.data.providers[0]
            },
            translatedText: "",
            translatedFiles: "",
            detectedLanguage: "",
            showDrop: false,
            hasPendingRequest: false,
            errors: {},
            timer: null,
            languages: [],
            languagesTpt:this.props.data.languagesTpt,
            filteredEngines: [],
            orgEngines:this.props.data.providers,
            pdf:false
        };
        this.onEngineChange = this.onEngineChange.bind(this);
        this.onProviderChange = this.onProviderChange.bind(this);
        this.onFromChange = this.onFromChange.bind(this);
        this.onToChange = this.onToChange.bind(this);
        this.onModelChange = this.onModelChange.bind(this);
        this.onTextInput = this.onTextInput.bind(this);
        this.onFileAdd = this.onFileAdd.bind(this);
        this.onFileRemove = this.onFileRemove.bind(this);
        this.onTextClear = this.onTextClear.bind(this);
        this.preventDragDefaults = this.preventDragDefaults.bind(this);
        this.onDrop = this.onDrop.bind(this);
        this.onDragOver = this.onDragOver.bind(this);
        this.onDragLeave = this.onDragLeave.bind(this);
        this.t
    }

    componentDidMount() { //all to change

        const languages = this.props.data.languages;
        const engines = this.state.filteredEngines = this.props.data.engines;
        const providers = this.props.data.providers;
        const account = this.props.data.account;

        const default_engine = engines.find((engine) => {
            return engine.pivot ? engine.pivot.is_default === 1 : false;
        });
        const default_provider =  providers[0];

        default_provider.is_default = true;
        this.onFromChange(this.state.model.from)

     /*    if (default_engine) {
            this.onEngineChange(default_engine);
            this.onProviderChange(providers.find((provider) => {
                return provider.id === default_engine.provider_id
            }));
        }else if (account && account.general_disabled && engines.length) {

            this.onEngineChange(engines[0]);
            this.onProviderChange(default_provider);
        } else {

            const model = {...this.state.model};
            const account = this.props.data.account;

            if (account && account.default_from) {
                model.from = languages.find((item) => item.id === account.default_from);
            }
            if (account && account.default_to) {
                model.to = languages.find((item) => item.id === account.default_to);
            }

            model.provider = default_provider;
            this.state.languages = model.provider ? model.provider.languages : [];
            this.setState({model: model});

            this.filterEngines(model.provider);
        } */
    }

    componentDidUpdate(prevProps) {
        if (prevProps.data.providers !== this.props.data.providers) {
            this.setState({model:{...this.state.model,provider:this.props.data.providers[0]}})
        }
    }

    handleAuto() {
        let autoValue 
        if (this.state.model.from.id === "auto" && this.state.detectedLanguage !== "") {
            autoValue = {id: "", name: langs[this.state.detectedLanguage] + " - Detected"}
            return autoValue
        }
        autoValue = this.state.model.from
        return autoValue 
    }

    render() {
        const languages = this.state.languages;
        const languagesFrom = this.sourceLanguages();
        const languagesTo = this.targetLanguages();
        const engines = this.state.filteredEngines;
        const providers = this.props.data.providers;
        const account = this.props.data.account;
        const languagesNames = languages.map((lang) => lang.name);
        const showDrop = this.state.showDrop
        const hasPendingRequest = this.state.hasPendingRequest;
        const canUpload = !this.props.documentHidden
        //const generalEngineEnabled = (this.state.model.provider && !this.state.model.provider.pivot.is_general_disabled);
        const engineSelected = !!this.state.model.engine;
        return (
            <div onDragEnter={this.preventDragDefaults}
                 onDragOver={this.onDragOver}
                 onDragLeave={this.preventDragDefaults}>
                {
                    showDrop ?
                    (<div onDragLeave={this.onDragLeave} onDrop={this.onDrop} className="amt-drop-zone">
                        <div className="amt-drop-content">
                            <div className="amt-drop-heading">Drag and drop...</div>
                            <div className="amt-drop-text">Add your file by dropping them anywhere in this
                                window
                            </div>
                        </div>
                    </div>) :
                    null
                }
                <div className="amt-translator">
                    <div className="amt-block">
                        <div className="amt-block-head">
                            <div className="amt-block-head-row">
                                <div className="amt-block-head-col col-1">
                                    <span className="amt-label">Translate from:</span>
                                </div>
                                <div className="amt-block-head-col col-2 from-to-block">
                                    <Dropdown document={this.props.document} isDisabled={false} filterCallback={this.filterLanguages} current={this.handleAuto()} /* current={this.state.model.from || (this.state.detectedLanguage ? {id: "", name: languages.find(lang => lang.id === this.state.detectedLanguage).name + ' - Detected'} : this.state.model.autoDetect) } */ itemClick={this.onFromChange}
                                              styled={this.props.styled} items={languagesFrom}/>
                                </div>
                            </div>
                            <div className="amt-block-head-row">
                                <div className="amt-block-head-col col-1">
                                    <a className="amt-block-switch btn" onClick={() => this.switchLanguages()}>
                                        { !this.canSwitchLanguages() ? '' :
                                            <img src={review} width="15" height="14"/>
                                        }
                                    </a>
                                </div>
                                <div className="amt-block-head-col col-2">
                                </div>
                            </div>
                            <div className="amt-block-head-row">
                                <div className="amt-block-head-col col-1">
                                    <span className="amt-label">Translate to:</span>
                                </div>
                                <div className="amt-block-head-col col-2 from-to-block">
                                    <Dropdown document={this.props.document} isDisabled={false} filterCallback={this.filterLanguages} current={this.state.model.to} itemClick={this.onToChange}
                                        styled={this.props.styled} items={languagesTo}/>
                                </div>
                            </div>
                        </div>
                        <TextInputBlock
                            onFileRemove={this.onFileRemove}
                            text={this.state.model.text}
                            files={this.state.model.files}
                            onTextInput={this.onTextInput}
                            onTextClear={this.onTextClear}
                            onFileAdd={this.onFileAdd}
                            canUpload={canUpload}
                            document={this.props.document}
                            styled={this.props.styled}
                            srcLang={this.state.model.from}
                        />
                    </div>
                    <div className="amt-controls">
                        <button type="button" onClick={() => this.translate()} className="amt-widget-button"
                                style={this.props.styled.button || {backgroundColor:"#6fb7e"}}>
                            {
                                hasPendingRequest
                                ? <span>
                                    Translating
                                    <span className="pending-request">
                                        <span>.</span><span>.</span><span>.</span>
                                    </span>
                                </span>
                                : <span>Translate</span>
                            }
                        </button>
                    </div>
                    <div className="amt-block">
                        <TextOutputBlock text={this.state.translatedText} files={this.state.translatedFiles} tgtLang={this.state.model.to}
                                         document={this.props.document} apiKey={this.props.apiKey} styled={this.props.styled}
                                         apiEndpoint={this.props.apiEndpoint} dow={this.getTranslatedFileById}
                                         resetLink={() => this.setState({translatedFiles: ""})}/>
                        <div className="amt-popvers-wrapper">
                            <Popover title="Formats" toggleText="Supported file formats" content={this.getFormatContent()} bottom="100%"
                                         left="0" document={this.props.document}/>
                        </div>
                    </div>
                    <ReactCSSTransitionGroup
                        transitionName="errors"
                        transitionEnterTimeout={500}
                        transitionLeaveTimeout={300}>
                    {
                        this.hasErrors() ? (
                                             <Errors key="errors" clearErrors={() => this.resetErrors()} errors={this.state.errors}/>
                                         ) :
                        null
                    }
                    </ReactCSSTransitionGroup>
                    <div className="amt-widget-engine-row">
                        <div className={`amt-widget-engine ${this.props.isStatic ? '' : 'popup-widget-engine'}`}>
                            <div className="amt-label">MT Provider:</div>
                            <Dropdown eng={true} document={this.props.document} current={this.state.model.provider} itemClick={this.onProviderChange}
                                        styled={this.props.styled} items={providers}/>
                        </div>
{/*                         <div className={`amt-widget-engine ${this.props.isStatic ? '' : 'popup-widget-engine'}`}>
                            <div className="amt-label">
                                <Popover title="Engines" toggleText={<>
                                <img src={info} width="16" height="16"/>

                                Engines:</>} content={this.getEnginesContent()} bottom="100%" right="0" document={this.props.document}/>
                            </div>
                            <Dropdown document={this.props.document} current={this.state.model.engine} itemClick={this.onEngineChange}
                                    styled={this.props.styled} hasEmpty={generalEngineEnabled} emptyOptionName="General" items={engines}/>
                        </div> */}
                    </div>
                </div>
            </div>
        );
    }


    sourceLanguages() {

 /*        const languages = [{'id': '', 'name': 'Auto-Detect Language'}, ...this.state.languages];

        if (this.state.model.to) {

            return languages.filter(language => language.id !== this.state.model.to.id)
        }

        return languages; */
        const languages = this.state.languagesTpt.reduce((acc,next) => {
            acc.push({id:next,name:langs[next]})
            return acc
        },[])
        languages.sort((a,b) => {return a.id === "auto" ? -1 : b.id === "auto" ? 1 : (a.name.toLowerCase() < b.name.toLowerCase()) ? -1 :(a.name.toLowerCase() > b.name.toLowerCase())? 1 : 0})
        return languages
    }

    targetLanguages() {

        const languages = this.state.languagesTpt.reduce((acc,next) => {
            if( next != "auto") {
                acc.push({id:next,name:langs[next]})
            }
            return acc
        },[])
        languages.sort((a,b) => {return (a.name.toLowerCase() < b.name.toLowerCase()) ? -1 :(a.name.toLowerCase() > b.name.toLowerCase())? 1 : 0})
        return languages
    }

    onFromChange(item) { // FILTER THE ENGINES AVAILABLE IF THEY SUPPORT SRC AND TGT
        let profileEngines = []
        let profileSource = this.props.data.profiles ?  this.props.data.profiles[item.id] : []
        if (profileSource) {
            let profileTarget = profileSource[this.state.model.to.id]
            if (profileTarget) {
                let newE = profileTarget.map(el => {
                    return {id:el.engine.id,name:el.engine.alias}
                })
                profileEngines = [...newE]
            }
        }
        let supportedEngines = this.state.orgEngines.filter(el => el.languages.includes(item.id) && el.languages.includes(this.state.model.to.id))
        if (item.id !== "auto") {
            this.up([...profileEngines,...supportedEngines])
           }   else {
            this.up([...this.state.orgEngines])
           }
        this.onModelChange("from", item);
        if(item.id) {
            this.onLanguageChange("from", item);
        }
    }

    up = (e) => this.props.updateProviderList(e)

    onToChange(item) {
        let profileEngines = []
        let profileSource = this.props.data.profiles ? this.props.data.profiles[this.state.model.from.id] : []
        if (profileSource) {
            let profileTarget = profileSource[item.id]
            if (profileTarget) {
                let newE = profileTarget.map(el => {
                    return {id:el.engine.id,name:el.engine.alias}
                })
                profileEngines = [...newE]
            }
        }
        let supportedEngines = this.state.orgEngines.filter(el => el.languages.includes(item.id) && el.languages.includes(this.state.model.from.id))
        this.up([...profileEngines,...supportedEngines])
        this.onModelChange("to", item);
        this.onLanguageChange("to", item);
        clearTimeout(this.t)
        this.setState({translatedText:""})
        this.t = setTimeout(() => this.translate(),1000)
    }

    onLanguageChange(prop, item) {

        let from = prop === 'from' ? item && item.id : (this.state.model.from ? this.state.model.from.id : null);
        let to = prop === 'to' ? item && item.id : (this.state.model.to ? this.state.model.to.id : null);

        let engine = this.props.data.engines.find(engine => engine.language_from === from && engine.language_to === to && (engine.pivot ? engine.pivot.is_default_per_pair : false))
            || this.props.data.engines.find(engine => engine.language_from === from && engine.language_to === to);

        if(!engine) {
            this.filterEngines(this.state.model.provider);
            this.state.model.engine = null;
            return 0;
        }

        let provider = this.props.data.providers.find(provider => provider.id === engine.provider_id);
        this.state.model.engine = engine.id ? engine : null;
        this.onProviderChange(provider);
    }

     onEngineChange(item) {
        if (item) {
            const from = this.props.data.languages.find((lang) => lang.id === item.language_from);
            const to = this.props.data.languages.find((lang) => lang.id === item.language_to);
            this.state.model.from = from;
            this.state.model.to = to;
        }
        this.onModelChange("engine", item);
    } 

    onProviderChange(item) {

        //this.state.languages = item.languages;

/*         if (item.pivot.is_general_disabled) {

            this.filterEnginesByProvider(item);

            let engines = this.state.filteredEngines.filter(engine => engine.language_from === this.state.model.from.id && engine.language_to === this.state.model.to.id);
            engines = engines.length ? engines : this.state.filteredEngines;

            this.state.model.from = this.state.languages.find(language => language.id === engines[0].language_from);
            this.state.model.to = this.state.languages.find(language => language.id === engines[0].language_to);

            this.state.model.engine = engines[0];
        } else {

            let from = this.state.languages.find(language => this.state.model.from && language.id === this.state.model.from.id);
            let to = this.state.languages.find(language => this.state.model.to && language.id === this.state.model.to.id);
            this.state.model.from = from ? from : this.state.model.autoDetect;
            this.state.model.to = to ? to : null;

            this.filterEngines(item);
            this.state.model.engine = this.state.model.engine && this.state.model.engine.provider_id == item.id ? this.state.model.engine : null;
        } */
        this.setState({model:{...this.state.model,provider:item}})
        this.onModelChange("provider", item);
    }

    filterEngines(item) {

        this.filterEnginesByProvider(item);

        this.state.filteredEngines = this.state.filteredEngines.filter((engine) => {
            return this.state.model.from !== null && engine.language_from === this.state.model.from.id
            && this.state.model.to !== null && engine.language_to === this.state.model.to.id
        });
    }

    filterEnginesByProvider(item) {
        this.state.filteredEngines = this.props.data.engines.filter((engine) => {
            return engine.provider_id === item.id && engine.id
        });
    }

    onModelChange(prop, item) {

        if (prop === 'files' || prop === 'text') {
            this.resetErrors('value');
        } else {
            this.resetErrors(prop);
        }

        this.state.model[ prop ] = item;
    }

    onTextInput(event) {

        this.onModelChange("text", event.target.value);

        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
            this.translate();
        }, 1000);
    }

    onFileAdd(event) {

        if (!this.isUploadsAvailable()) {
            return;
        }

        const source = (event.dataTransfer) ? event.dataTransfer : event.target;
        let hasDuplicates = false;

        const files = (source.files.length) ? [...Array.from(source.files)] : [];
        const oldFiles = [ ...this.state.model.files ];

        files.forEach((file) => {
            if (file)
            oldFiles.forEach((oldFile) => {

                if(file.name === oldFile.name) {

                    hasDuplicates = true;
                }
            });
        });

        if (hasDuplicates) {

            this.setError('files', 'You can not upload same file twice');

            return
        }
        let pdf = files.some(file => file.type === "application/pdf")
        this.setState({pdf:pdf})
        this.onModelChange("files", [ ...oldFiles, ...files ]);
    }

    onFileRemove(file) {

        const files = [ ...this.state.model.files ];
        const index = files.indexOf(file);
        files.splice(index, 1);

        this.onModelChange("files", files);
    }

    onTextClear() {

        this.onModelChange("text", "");
        this.setState({ translatedText: "" });
    }

    preventDragDefaults(event) {
        event.preventDefault();
        event.stopPropagation();
    }

    onDrop(event) {

        if (!this.isUploadsAvailable()) {
            return;
        }

        this.preventDragDefaults(event);

        this.onFileAdd(event);
        this.setState({
                          showDrop: false,
                      });
    }

    onDragOver(event) {

        if (this.props.documentHidden) {
            return;
        }

        this.preventDragDefaults(event);
        this.setState({
                          showDrop: true,
                      });
    }

    onDragLeave(event) {

        if (!this.isUploadsAvailable()) {
            return;
        }

        this.preventDragDefaults(event);
        this.setState({
                          showDrop: false,
                      });
    }

    switchLanguages() {

        if (this.canSwitchLanguages()) {
            const from = this.state.model.from;
            const to = this.state.model.to;

            this.onFromChange(to);
            this.onToChange(from);
        }
    }

    canSwitchLanguages() {
        return this.state.model.from.id !== "auto"
        /* return this.state.model.from
            && this.state.model.from.id
            && this.state.model.to && this.state.model.provider
            && !this.state.model.provider.pivot.is_general_disabled */
    }

    translate() {

        this.resetErrors();
        this.setState({
                          translatedFiles: "",
                          detectedLanguage: "",
        });

        if (!this.validate()  || this.state.hasPendingRequest) {

            return;
        }

        this.setState({hasPendingRequest: true});

        if (this.state.model.files.length > 0) {

            this.translateFiles();

            this.timer = setTimeout(() => {
                this.showLongTranslationMessage();
            }, 40000);
        } else {

            this.translateText();
        }
    }

    showLongTranslationMessage() {

        this.setState({
            errors: {server: 'Translating this file might take longer time. Please be patient.'},
            hasPendingRequest: true
        });
    }

    translateText() {

        let model = {...this.state.model};
        let tptbody = [{Text:this.state.model.text}]
        delete model.files;

        model.to = model.to.id;
        model.from = model.from ? model.from.id : "";
        model.provider = model.provider.code;

        const request = this.props.http.post(`/apigateway/texttranslator?from=${this.state.model.from.id}&to=${this.state.model.to.id}&textType=text&engineId=${this.state.model.provider.id}`, tptbody);

        request.then(
            (response) => {
                this.setState({
                                  translatedText: response.data.message.length > 0 ? response.data.message[0].Text : "",
                                  hasPendingRequest: false,
                                  detectedLanguage: response.data.message.length > 0 && response.data.message[0].detectedLanguage ? response.data.message[0].detectedLanguage : "",
                              });
            },
            (error) => {

                this.errorHandler(error.response);
            }
        );
    }

    translateFiles() {

        const formData = new FormData();
        let model = {...this.state.model};
        //formData.append('provider', model.provider.code);
        model.files.forEach((file, index) => {
            formData.append('files',file)
            //formData.append(`files[${index}]`, file);
        });
/*         if (model.engine) {

            Object.keys(model.engine).forEach((key) => {

                formData.append(`engine[${key}]`, model.engine[ key ]);
            })
        } */

        const request = this.props.http.post(`/uploadapigateway/upload/documentTranslate?from=${model.from.id}&to=${model.to.id}&ocr=${this.state.pdf}&engineId=${this.state.model.provider.id}`, formData, {headers: {'Content-Type': 'multipart/form-data'}});

        request.then(
            (response) => {
                let result = response.data.success;
                const submissionId = response.data.submissionId;
                var timerId;

                    timerId = setInterval(() => {
                        this.props.http.get(`/apigateway/storage/info/submission/${submissionId}`).then((response) => {
                            let job = response.data;
                            let done = job.files.every(el =>  el.status !== 'Uploading' &&
                            el.status !== 'Processing' &&
                            el.status !== 'DocumentTranscribing' &&
                            el.status !== 'DocumentTranscribed')
                            if (done) {
                                clearInterval(timerId);
                                clearTimeout(this.timer);
                                this.setState({
                                    hasPendingRequest: false,
                                    translatedFiles: job.files
                                });
                            }
  /*                           if (parseInt(job.status) === 2 && job.result) {
                                clearInterval(timerId);
                                clearTimeout(this.timer);
                                this.setState({
                                    errors: {server: job.result},
                                    hasPendingRequest: false
                                });
                            } */
                        }, (error) => {
                            clearInterval(timerId);
                            clearTimeout(this.timer);
                            this.errorHandler(error.response);
                        });
                    }, 5000);
                
            },
            (error) => {

                this.errorHandler(error.response);
                clearTimeout(this.timer);
            }
        );
    }

    filterLanguages(item, str) {
        return item.name ? item.name.toLowerCase().startsWith(str.toLowerCase()) : "bob"
    }

    validate() {

        const errors = {};

        if (!this.state.model.text.trim() && !this.state.model.files.length) {
            errors.value = 'Text or files for translation are required';
        }

        if (!this.state.model.to) {
            errors.to = 'Target language is required';
        }

        if (!this.state.model.from && this.state.model.files.length) {
            errors.from = 'Source language is required';
        }

        this.setState((state, props) => {

            return {errors: {...state.errors, ...errors}};
        });

        return !Object.keys(errors).length;
    }
    getTranslatedFileById =  (fileId) => {
        if (typeof fileId === "undefined") {
            return
        }
        try {
            const request = this.props.http.get(`/apigateway/storage/${fileId}?fileType=translated_file`,{responseType:'blob'})
            request.then(blob => {
                var url = window.URL.createObjectURL(blob.data);
                var a = document.createElement('a');
                a.href = url;
                let fname = blob.headers.filename;
                let decoded = decodeURIComponent(
                  fname.replace(/\+/g, ' ')
                );
                a.download = decoded || file.fileName;
                document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
                a.click();
                a.remove(); //afterwards we remove the e
            })    
        } catch (error) {
            console.error(error);
        }
    };

    // download translated files
    download(url) {

        //iOS devices do not support downloading. We have to inform user about this.
        if (/(iP)/g.test(window.navigator.userAgent)) {

            window.open(url, '_blank');
            return false;
        }

        //If in Chrome or Safari - download via virtual link click
        if (this.isChrome() || this.isSafari()) {

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('target', '_blank');

            if (this.isDefined(link.download)) {

                const fileName = url.substring(url.lastIndexOf('/') + 1, url.length);
                link.download = fileName;
            }

            if (document.createEvent) {

                const e = document.createEvent('MouseEvents');
                e.initEvent('click', true, true);
                link.dispatchEvent(e);
                return true;
            }
        }

        window.open(url, '_blank');
        return true;
    }

    isChrome() {

        return this.isBrowser('chrome');
    }

    isSafari() {

        return this.isBrowser('safari');
    }

    isBrowser(tag) {

        return window.navigator.userAgent.toLowerCase().indexOf(tag) > -1;
    }

    isDefined(value) {

        return typeof value !== 'undefined';
    }

    getEnginesContent() {

        const account = this.props.data.account;

        return (
            <div>
                <p>An engine is a database used as the basis for the machine
                    translation.</p>
                <p>The General engine (available in all languages) is trained in all types
                    of texts and will translate the text you input using the most commonly
                    used terms for the language. It is a quick way to gain an understanding
                    of the text you have entered.</p>
                <p>You can also add additional engines (e.g. Legal, Finance, Technical, or
                    Medicine), or a list of specific terms, which will improve the quality
                    of the machine translation output.</p>

                {
                    account
                    ? (
                                <p>
                                    (Contact information Sales Manager: <br/>
                                    {account.sales_person_name ? (<span>{account.sales_person_name} <br/></span>) : null}
                                    {account.sales_person_phone ? (<span>{account.sales_person_phone} <br/></span>) : null}
                                    {account.sales_person_email ? (<span>{account.sales_person_email}</span>) : null})
                                </p>
                    )
                    : null
                }

            </div>
        );
    }

    getFormatContent() {
        return (
            <div>
                <p>
                    <span>Supported file formats</span>
                    <br/><br/>
                    <span>
                    doc, docm, docx, dot, dotm, dotx, html, jpg, odp, ods, odt, pdf, png, ppt, pptx, rtf, txt, xls, xlsm, xlsx
                    </span>
                </p>
            </div>
        );
    }

    isUploadsAvailable() {

        return (this.props.data.account && this.props.data.account.file_uploads);
    }

    errorHandler(error) {

        let errorMsg;

        if (error.status === 422) {
            if(error.data && error.data.errors){
                let errors = error.data.errors;
                const field = Object.keys(errors)[0];
                errorMsg = errors[field][0];
            } else {
                errorMsg = "Invalid Data";
            }
            console.log(error);
        } else if (error.status === 401 || error.status === 403) {

            errorMsg = "Authorization Error";
        } else if (error.status === 504) {
            errorMsg = 'The time waiting for a response from the server is very long, please try to upload a smaller file or fewer files';
        } else {
            errorMsg = error.data.message;
        }

        this.setState({
                          errors: {server: errorMsg},
                          hasPendingRequest: false
                      });
    }

    resetErrors(prop = null) {

        if (prop) {
            this.setState((state, props) => {

                const errors = {...state.errors};

                const filteredErrors = Object.keys(errors).reduce((newErrors, error) => {
                    if (error !== prop) {
                        newErrors[error] = errors[error];
                    }

                    return newErrors;
                }, {});

                return {errors: filteredErrors};
            });
        } else {
            this.setState((state, props) => {

                return {errors: {}};
            });
        }
    }

    setError(field, message) {

        this.setState((state, props) => {

            const errors = {...state.errors};
            errors[field] = message;

            return {errors: errors};
        });
    }

    hasErrors() {

        return !!Object.keys(this.state.errors).length;
    }
}
